/* Logic and data */
import service from '@busyrooms/ibe-core/data/service'

import type { IStaticConfiguration, PlayitasScenarioParams } from './types'

import '@/assets/styles/index.css'
import { AxiosRequestConfig } from 'axios'

/**
 * Mounts the specified scenario with the provided configuration
 * @param params Scenario mounting params
 */
export default async function mountScenario (
  staticConfiguration: IStaticConfiguration,
  params: PlayitasScenarioParams
) {
  // Fetch configuration from the DB
  // const ibeConfiguration = await getIBEConfiguration<PlayitasFetchedClientConfiguration>(
  //   params.appId,
  //   params.appToken
  // )

  /* Set API endpoints */
  const apiURL = staticConfiguration.apiBaseUrl || ''
  const apiURLSuffix = staticConfiguration.apiSuffix || ''
  service.setCoreApiPath(apiURL + '/braridata' + apiURLSuffix)
  service.setApiPath(apiURL + '/legacy' + apiURLSuffix)

  /** Set X-Correlation for development */
  if (process.env.NODE_ENV !== 'production') {
    service.coreApiHttp.defaults.headers.common['X-Correlation'] = staticConfiguration.apiToken
    service.http.defaults.headers.common['X-Correlation'] = staticConfiguration.apiToken
  }

  /** Mitigates CORS in production setting */
  const rewriteToTextPlain = (config: AxiosRequestConfig) => {
    config.headers ||= {}
    config.headers['Content-Type'] = 'text/plain'
    return config
  }

  service.coreApiHttp.defaults.responseType = 'json'
  service.http.defaults.responseType = 'json'

  service.coreApiHttp.interceptors.request.use(rewriteToTextPlain)
  service.http.interceptors.request.use(rewriteToTextPlain)

  // Since Playitas is the first IBEv5 to be in production,
  // the client uses `mountIBE` for compat reasons
  if (params.scenario === 'single_property') {
    return (await import('@/scenarios/SingleProperty')).default(staticConfiguration, params)
  }
}
